import type { ResponseType } from '../types/responses';
import type { PdfPreviewSnapshot } from '../types/pdfPreview';
import { apiClient } from './apiClient';

export const pdfPreviewProvider = {
  getPreview: (
    previewId: string,
    signal?: AbortSignal
  ): Promise<ResponseType<PdfPreviewSnapshot>> =>
    apiClient<PdfPreviewSnapshot>(
      `/ai-listing/pdf-previews/${encodeURIComponent(previewId)}`,
      'GET',
      null,
      { signal }
    ),

  getMedia: (
    previewId: string,
    mediaId: string,
    signal: AbortSignal
  ): Promise<ResponseType<Blob>> =>
    apiClient<Blob>(
      `/ai-listing/pdf-previews/${encodeURIComponent(previewId)}/media/${encodeURIComponent(mediaId)}`,
      'GET',
      null,
      { responseType: 'blob', signal }
    ),
};
